import get from 'lodash.get'

function scoreRow (row, accessors) {
  if (!row || !accessors?.length) return { resolved: 0, leaf: 0 }
  let resolved = 0
  let leaf = 0
  for (const a of accessors) {
    const v = get(row, a.accessor)
    if (v !== undefined && v !== null) {
      resolved++
      if (typeof v !== 'object') leaf++
    }
  }
  return { resolved, leaf }
}

// BFS over rows and any nested `data[]` arrays. Cursor index instead of
// shift() so large datasets don't pay O(n²) for repeated re-indexing.
function findExampleRow (rows, accessors) {
  if (!Array.isArray(rows) || rows.length === 0) return null
  if (!accessors?.length) return rows[0]
  let bestRow = null
  let best = { resolved: -1, leaf: -1 }
  const queue = [...rows]
  let head = 0
  while (head < queue.length) {
    const row = queue[head++]
    if (!row) continue
    const score = scoreRow(row, accessors)
    if (score.resolved === accessors.length && score.leaf === accessors.length) return row
    if (score.leaf > best.leaf || (score.leaf === best.leaf && score.resolved > best.resolved)) {
      best = score
      bestRow = row
    }
    if (Array.isArray(row.data) && row.data.length > 0) {
      queue.push(...row.data)
    }
  }
  return bestRow
}

export function pickExampleRow (cachedData, dataAccessor, accessors) {
  if (!cachedData) return null
  if (!dataAccessor) {
    // Components that read rows directly from the pipeline result (no
    // dataAccessor) hand us the row array — example lookups need to run
    // against an actual row, not the array itself.
    return Array.isArray(cachedData) ? findExampleRow(cachedData, accessors) : cachedData
  }
  const rows = get(cachedData, dataAccessor)
  return findExampleRow(rows, accessors)
}
